import type { ReactNode } from "react";
import { StyleSheet, View } from "react-native";

import { AppText } from "./AppText";
import { spacing, useThemedStyles, type ThemeColors } from "~/styles/theme";

/** Label ↔ value row with a hairline divider — for detail screens. */
export function DetailRow({
  label,
  value,
}: {
  label: string;
  value: ReactNode;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  return (
    <View style={stylesheet.row}>
      <AppText size="sm">{label}</AppText>
      {typeof value === "string" || typeof value === "number" ? (
        <AppText weight="semibold">{String(value)}</AppText>
      ) : (
        value
      )}
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    row: {
      minHeight: 40,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
      paddingVertical: spacing.s,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: colors.border,
    },
  });
